import React, { useState, useEffect } from "react";

const OrderNotes = ({ orderId }) => {
    const [notes, setNotes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (orderId) {
            fetchNotes();
        }
    }, [orderId]);

    const fetchNotes = () => {
        setLoading(true);
        const url = `${EASYCOMMERCE.rest_base}/orders/${orderId}/notes`;
        
        fetch(url, {
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            }
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Filter notes to only show customer-facing notes
                const customerNotes = data.data
                    .map(note => ({
                        id: note.id,
                        content: note.content,
                        timestamp: new Date(note.created_at).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                        })
                    }));
                setNotes(customerNotes);
            }
            setLoading(false);
        })
        .catch(error => {
            console.error('Error fetching notes:', error);
            setNotes([]);
            setLoading(false);
        });
    };

    if (loading) {
        return (
            <div className="easycommerce-dashboard-order-iteam p-1 md:p-7 col-span-1 border border-ec-border rounded-lg">
                <div className="p-4">Loading notes...</div>
            </div>
        );
    }

    // Only show the section if there are notes
    if (notes.length === 0) {
        return null;
    }

    return (
        <div className="easycommerce-dashboard-order-iteam p-1 md:p-7 col-span-1 border border-ec-border rounded-lg">
            <div className="p-4">
                <h3 className="font-inter font-semibold text-base md:text-xl text-left leading-8 text-ec-body p-0 pl-4 pb-6 border-0 border-b border-ec-border">
                    Order Notes
                </h3>
                
                <div className="space-y-4 mt-4">
                    {notes.map((note) => (
                        <div key={note.id} className="bg-gray-50 p-4 rounded-lg">
                            <p className="text-ec-body mb-2">
                                {note.content}
                            </p>
                            <div className="text-sm text-ec-light-black">
                                {note.timestamp}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default OrderNotes;